import { motion } from 'framer-motion';

const ToggleItem = ({
  title,
  description,
  checked,
  onChange,
  disabled = false,
  destructive = false,
}) => (
  <div className="flex items-center justify-between gap-4 py-3.5 first:pt-0 last:pb-0">
    <div className="min-w-0 flex-1">
      <p
        className={`text-sm font-semibold ${
          destructive
            ? 'text-red-600 dark:text-red-400'
            : 'text-surface-900 dark:text-white'
        }`}
      >
        {title}
      </p>
      {description ? (
        <p className="mt-0.5 text-xs leading-relaxed text-surface-500 dark:text-surface-400">
          {description}
        </p>
      ) : null}
    </div>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative isolate h-7 w-12 shrink-0 overflow-visible rounded-full p-0.5 transition-colors disabled:opacity-50 ${
        checked ? 'bg-brand-500' : 'bg-surface-300 dark:bg-surface-600'
      }`}
    >
      <motion.span
        className="block h-6 w-6 rounded-full bg-white shadow-sm"
        initial={false}
        animate={{ x: checked ? 20 : 0 }}
        transition={{ type: 'spring', stiffness: 500, damping: 35 }}
      />
    </button>
  </div>
);

export default ToggleItem;
